import axios from "axios";
import { CommonContext } from "hooks/CommonContext";
import React, { useContext, useState } from "react";
import { HiOutlineExternalLink } from "react-icons/hi";
const { REACT_APP_CLOUD_FUNCTIONS_URL } = process.env;
export const blank = "_blank";
export const noopener = "noopener";

const STYLES = `
  .ocr-btn {
    all: unset;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-size: 13.5px;
    font-weight: 500;
    color: #22d3ee;
    transition: color 0.15s ease, opacity 0.15s ease;
    line-height: 1.4;
  }

  .ocr-btn:hover:not(:disabled) {
    color: #67e8f9;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  .ocr-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    text-decoration: none;
  }

  .ocr-icon {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    font-size: 16px;
    opacity: 0.8;
  }

  /* Loading spinner */
  .ocr-spinner {
    width: 13px;
    height: 13px;
    border: 2px solid rgba(34, 211, 238, 0.25);
    border-top-color: #22d3ee;
    border-radius: 50%;
    animation: ocrSpin 0.7s linear infinite;
    flex-shrink: 0;
  }

  @keyframes ocrSpin {
    to { transform: rotate(360deg); }
  }
`;

let _inj = false;
const inject = () => {
  if (_inj) return;
  const s = document.createElement("style");
  s.textContent = STYLES;
  document.head.appendChild(s);
  _inj = true;
};

const OpenCandidateResume = () => {
  inject();
  const { interviewDetails } = useContext(CommonContext);
  const [loadingResumes, setLoadingResumes] = useState(false);

  const fetchResume = async (filePath, bucketName) => {
    setLoadingResumes(true);
    try {
      const { data } = await axios.get(
        `${REACT_APP_CLOUD_FUNCTIONS_URL}/get-signed-url?document_link=${filePath}&bucket_name=${bucketName}`
      );
      if (data.signed_url) {
        window.open(data.signed_url, blank, noopener);
      } else {
        console.error("No signed URL received");
      }
    } catch (error) {
      console.error("Error fetching signed URL:", error);
    } finally {
      setLoadingResumes(false);
    }
  };

  const firstName = interviewDetails?.candidateDetails?.firstName ?? "";
  const lastName = interviewDetails?.candidateDetails?.lastName ?? "";
  const disabled = loadingResumes || interviewDetails?.candidateDocument === undefined;

  return (
    <button
      type="button"
      className="ocr-btn"
      disabled={disabled}
      onClick={() =>
        fetchResume(
          interviewDetails?.candidateDocument?.documentLink,
          interviewDetails?.candidateDocument?.bucketName
        )
      }
    >
      {firstName} {lastName} – Resume.pdf
      <span className="ocr-icon">
        {loadingResumes
          ? <span className="ocr-spinner" />
          : <HiOutlineExternalLink />
        }
      </span>
    </button>
  );
};

export default OpenCandidateResume;